import React, { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Instagram, Twitter, Linkedin, User } from 'lucide-react';
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import TeamRobotCard from './TeamRobotCard';
import { EvervaultCard, Icon } from './ui/evervault-card';

const Team = () => {
    const [team, setTeam] = useState([]);

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const { data } = await api.get('/team');
                setTeam(data);
            } catch (error) {
                console.error("Failed to fetch team members", error);
            }
        };
        fetchTeam();
    }, []);

    useGSAP(() => {
        gsap.to('#team-heading', {
            y: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: '#team-heading',
                start: 'top 85%',
            }
        })
    }, []);

    return (
        <section id="team" className="common-padding bg-white dark:bg-zinc relative overflow-hidden transition-colors duration-300">
            <div className="screen-max-width">
                <div className="mb-12 w-full text-center">
                    <h1 id="team-heading" className="section-heading text-black dark:text-white">Meet Our Team.</h1>
                </div>

                <div className="flex flex-wrap justify-center gap-10 mt-10">
                    {team.length === 0 ? (
                        <p className="text-gray-400">Team info coming soon...</p>
                    ) : (
                        team.map((member, index) => (
                            <React.Fragment key={member._id}>
                                <div className="border border-black/10 dark:border-white/[0.2] flex flex-col items-start max-w-sm p-4 relative h-[30rem] w-[320px] bg-white dark:bg-zinc rounded-xl transition-colors duration-300 shadow-sm dark:shadow-none">
                                    <Icon className="absolute h-6 w-6 -top-3 -left-3 dark:text-white text-gray-400" />
                                    <Icon className="absolute h-6 w-6 -bottom-3 -left-3 dark:text-white text-gray-400" />
                                    <Icon className="absolute h-6 w-6 -top-3 -right-3 dark:text-white text-gray-400" />
                                    <Icon className="absolute h-6 w-6 -bottom-3 -right-3 dark:text-white text-gray-400" />

                                    <div className="w-full h-64 mb-4">
                                        <EvervaultCard
                                            text={member.name.split(' ')[0]}
                                            imageUrl={member.image ? (member.image.startsWith('http') ? member.image : `${import.meta.env.VITE_API_URL.replace('/api', '')}${member.image}`) : null}
                                            className="h-full"
                                        />
                                    </div>

                                    <div className="flex flex-col w-full mt-4">
                                        <h3 className="text-xl font-bold text-white mb-1">{member.name}</h3>
                                        <p className="text-blue-400 text-sm font-medium mb-4">{member.role}</p>

                                        <div className="flex gap-4 mt-2">
                                            {member.socials?.instagram && (
                                                <a href={member.socials.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                                                    <Instagram className="w-5 h-5" />
                                                </a>
                                            )}
                                            {member.socials?.twitter && (
                                                <a href={member.socials.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                                                    <Twitter className="w-5 h-5" />
                                                </a>
                                            )}
                                            {member.socials?.linkedin && (
                                                <a href={member.socials.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                                                    <Linkedin className="w-5 h-5" />
                                                </a>
                                            )}
                                        </div>
                                    </div>

                                    <p className="text-xs border font-light dark:border-white/[0.2] border-black/[0.2] rounded-full mt-auto text-gray-400 px-2 py-0.5">
                                        Team Member
                                    </p>
                                </div>
                                {/* Handoff Robot Card: Insert after 2nd member or if it's the only member */}
                                {(index === 1 || (team.length === 1 && index === 0)) && (
                                    <TeamRobotCard />
                                )}
                            </React.Fragment>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
};

export default Team;
